<td>{{ user.name}}</td>
<td>
  <div *ngFor="let d of user.departments" class="flex items-center justify-center">{{ d }}</div>
</td>
<td><div class="flex items-center justify-center">{{ user.logInfo | statusDate }}</div></td>
<td>
  <div *ngFor="let r of user.roles" class="flex items-center justify-center">
    <p-tag class="my-1" [value]="getRoleName(r) | translate" [severity]="getRoleSeverity(r)" [rounded]="true" />
  </div>
</td>
<td>
  @if(!showDisabled) {
  <p-button [disabled]="showDisabled" (click)="onShowDialog()">
    @if(isShowing) {
    <i class="pi pi-spin pi-spinner"></i>
    } @else {
    <i class="pi pi-user-edit"></i>
    }
  </p-button>
  }
</td>
